var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5315 26C20.4973 26 26.1441 20.3531 26.1441 13.3874C26.1441 6.42163 20.4973 0.774773 13.5315 0.774773C6.56577 0.774773 0.918915 6.42163 0.918915 13.3874C0.918915 20.3531 6.56577 26 13.5315 26Z",
    fill: "#D6502A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76215 6.08002L11.7908 14.1408L5.72415 20.6946H7.08962L12.4011 14.9565L16.6925 20.6946H21.3389L14.9709 12.1805L20.6178 6.08002H19.2523L14.3609 11.3645L10.4086 6.08002H5.76215ZM7.77013 7.08571H9.90469L19.3307 19.6889H17.1961L7.77013 7.08571Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.2252,
    height: 25.2252,
    fill: "white",
    transform: "translate(0.918915 0.774773)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.048bc1045053d53f7372ccb865c76e1c.svg";
export { ForwardRef as ReactComponent };